export default __webpack_public_path__ + "static/media/arms.0be6f3c3.png";